import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationType } from 'app/core/models/confirmation-type.enum';
import { ActionConfirmationComponent } from 'app/shared/components/action-confirmation/action-confirmation.component';
import { BzgModalService } from 'bz-genome-angular';
import { I18nService } from 'i18n/i18n.service';
import { MaintenanceStatus } from '../core/services/maintenance-status.enum';

@Component({
  selector: 'full-restart-service',
  templateUrl: './full-restart-service.component.html',
  styleUrls: ['./full-restart-service.component.scss']
})
export class FullRestartServiceComponent implements OnInit {
  @Input() status: MaintenanceStatus = MaintenanceStatus.ACTIVE;
  @Output() restartWebApps = new EventEmitter();
  @Output() verifyServiceAvailability = new EventEmitter();
  constructor(
    private _i18nService: I18nService,
    private _modalService: BzgModalService
  ) { }

  ngOnInit() {
  }

  restartService() {
    const title = this._i18nService.instant("MAINTENANCE.RESTART_SERVICE");
    const message = this._i18nService.instant("MAINTENANCE.RESTART_SERVICE_MESSAGE");
    const button = this._i18nService.instant("GLOBAL.RESTART");
    const modal = this._modalService.open(ActionConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: { title, message, type: ConfirmationType.RESTART, button }
    });
    modal.afterClosed().subscribe((result) => {
      if(result === ConfirmationType.RESTART) {
        this.status = MaintenanceStatus.RESTARTING;
        this.restartWebApps.emit();
      }
    });
  }

  verifyService() {
    this.verifyServiceAvailability.emit();
  }

  get isRestartingService(){
    return this.status === MaintenanceStatus.RESTARTING || this.status === MaintenanceStatus.VERIFYING || this.status === MaintenanceStatus.ERROR
  }

}
